module.exports = __webpack_public_path__ + "static/media/elcano_1.1cae33bc.png";